import Header from "../components/landing/Header";
import Hero from "../components/landing/Hero";
import BuiltBy from "../components/landing/BuiltBy";
import Services from "../components/landing/Services";
import ROIStats from "../components/landing/ROIStats";
import BookCallBanner from "../components/landing/BookCallBanner";
import Contact from "../components/landing/Contact";
import Footer from "../components/landing/Footer";
import useLenis from "../hooks/useLenis";

export default function LandingPage() {
  useLenis();

  return (
    <main
      data-testid="landing-page"
      className="relative min-h-screen bg-[#020617] text-slate-100 font-body"
    >
      <Header />
      <Hero />
      <BuiltBy />
      <Services />
      <ROIStats />
      <BookCallBanner />
      <Contact />
      <Footer />
    </main>
  );
}
